import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Route, useHistory, useLocation } from 'react-router-dom';

import { FadeWrapper } from './Landing.styled';
import About from './About';
import FAQ from './FAQ';
import Login from './Login';

function Landing(): React.ReactElement {
  const faqRef = useRef(null);
  const aboutRef = useRef(null);
  const loginRef = useRef(null);

  const history = useHistory();
  const location = useLocation();

  const validURLS = ['/faq', '/about', '/'];
  if (!validURLS.some((url) => url === location.pathname)) {
    history.push('/');
  }

  return (
    <>
      <div style={{ position: 'relative' }}>
        <Route exact path="/faq">
          {({ match }) => (
            <CSSTransition
              in={match !== null}
              timeout={300}
              nodeRef={faqRef}
              classNames="fade"
              unmountOnExit
            >
              <FadeWrapper ref={faqRef}>
                <FAQ />
              </FadeWrapper>
            </CSSTransition>
          )}
        </Route>
        <Route exact path="/about">
          {({ match }) => (
            <CSSTransition
              in={match !== null}
              timeout={300}
              nodeRef={aboutRef}
              classNames="fade"
              unmountOnExit
            >
              <FadeWrapper ref={aboutRef}>
                <About />
              </FadeWrapper>
            </CSSTransition>
          )}
        </Route>
        <Route exact path="/">
          {({ match }) => (
            <CSSTransition
              in={match !== null}
              timeout={300}
              nodeRef={loginRef}
              classNames="fade"
              unmountOnExit
            >
              <FadeWrapper ref={loginRef}>
                <Login />
              </FadeWrapper>
            </CSSTransition>
          )}
        </Route>
      </div>
    </>
  );
}

export default Landing;
